jQuery(function ($) {
  'use strict';
  /**
    Create an HTML file with this template to test

    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <title>Page Title</title>
      <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.2/css/bootstrap.min.css">
      <link rel="stylesheet" href="http://test.localhost.dev:8000/assets/stylesheets/signup.css">
    </head>
    <body>
      <div data-templates-section></div>
      <script>
      // use 'https://my.flyerco.com' in production;
      window.flyercoAppUrl = 'http://test.localhost.dev:8000';
      </script>

      <script src="https://ajax.googleapis.com/ajax/libs/jquery/1.11.2/jquery.min.js"></script>

      <!-- // use 'https://my.flyerco.com' in production-->
      <script src="http://test.localhost.dev:8000/assets/javascripts/signup.js"></script>

      <script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.2/js/bootstrap.min.js"></script>
      </body>
    </html>
  **/

  var TEMPLATES_URL = window.flyercoAppUrl + '/templates';
  var FLYERS_CREATE_URL = window.flyercoAppUrl + '/flyers/create';
  var dialogTemplate = window.JST['signup.html']();
  var $signupModal = $(dialogTemplate);

  $('body').append($signupModal);

  var $signupForm = $('form[data-signup-form]');
  var $signupAlert = $signupForm.find('[data-alert]');
  var $signupSubmit = $signupForm.find('input[type=submit]');
  var templateId;

  $.ajax({
    url: TEMPLATES_URL,
    type: 'GET',
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    },
    success: function (data) {
      var categories = data.categories;

      var templateSection = window.JST['flyer-templates.html']({
        categories: categories
      });

      $('[data-templates]').append(templateSection);
    }
  });

  function  getCrfToken() {
    return $.ajax({
      url: window.flyercoAppUrl + '/csrf_token',
      type: 'GET',
      xhrFields: {
        withCredentials: true
      }
    });
  }

  function sendUserRequest(data, url) {
    return $.ajax({
      url: url,
      type: 'POST',
      data: data,
      xhrFields: {
        withCredentials: true
      },
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
  }

  function showAlert(error, $elmt) {
    try {
      error = JSON.parse(error);

      if ($.isArray(error) && error.length === 0) {
        error = error[0];
      }
    } catch (e) {

    }

    if ($.isArray(error)) {
      var ul = '<ul>';
      for (var i = 0; i < error.length; i++) {
        ul += '<li>' + error[i] + '</li>';
      }
      ul += '</ul>';

      $elmt.show().html(ul);
    } else {
      $elmt.show().html(error);
    }
  }

  $signupForm.submit(function (e) {
    e.preventDefault();

    $signupSubmit.prop('disabled', true);
    $signupAlert.hide();

    getCrfToken().done(function (token) {
      var firstName = $signupForm.find('[data-first-name]').val();
      var lastName = $signupForm.find('[data-last-name]').val();
      var email = $signupForm.find('[data-email]').val();
      var password = $signupForm.find('[data-password]').val();
      var sponsor = $signupForm.find('[data-sponsor]').val();

      // jscs:disable disallowDanglingUnderscores
      var data = {
        _token: token, // jshint ignore:line
        first_name: firstName, // jshint ignore:line
        last_name: lastName, // jshint ignore:line
        email: email,
        password: password,
        sponsor: sponsor
      };
      // jscs:enable disallowDanglingUnderscores

      sendUserRequest(data, window.flyercoAppUrl + '/auth/register')
      .done(function () {
        if (templateId) {
          window.location = FLYERS_CREATE_URL + '?template=' + templateId;
        } else {
          window.location = TEMPLATES_URL;
        }
      })
      .fail(function (res) {
        showAlert(res.responseText, $signupAlert);
        $signupSubmit.prop('disabled', false);
      });
    });
  });

  $('[data-templates]').on('click', 'a.button-template-choose', function (e) {
    templateId = $(e.currentTarget).data('template-id');
  });
});
